export default "__VITE_ASSET__3c7f3e7e__"